module.exports = __webpack_public_path__ + "static/media/PoochIcon.5ffcee59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditPooch/PoochIcon.svg
// module id = 344
// module chunks = 0